import { CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query'
import { BuildQueryProps } from 'utils/QueryHelpers'

export const normalizeUsersSearchQuery = (
  filterDescriptor: FilterDescriptor[] | CompositeFilterDescriptor
): BuildQueryProps => {
  const gridFilterDescriptor = filterDescriptor as CompositeFilterDescriptor
  const filters = gridFilterDescriptor.filters.map(
    (x: FilterDescriptor | CompositeFilterDescriptor) => {
      const filterItem = x as FilterDescriptor

      if (filterItem.field === 'email') {
        return {
          ...filterItem,
          field: 'Email',
          value: filterItem?.value,
        }
      }

      if (filterItem.field === 'firstName') {
        return {
          ...filterItem,
          field: 'Firstname',
          value: filterItem?.value,
        }
      }

      if (filterItem.field === 'lastName') {
        return {
          ...filterItem,
          field: 'Lastname',
          value: filterItem?.value,
        }
      }

      if (filterItem.field === 'status.name') {
        return {
          ...filterItem,
          field: 'Status',
          value: filterItem?.value,
        }
      }

      if (filterItem.field === 'kind.name') {
        return {
          ...filterItem,
          field: 'Kind',
          value: filterItem?.value,
        }
      }

      if (filterItem.field === 'teams.name') {
        return {
          ...filterItem,
          field: 'Team',
          value: filterItem?.value,
        }
      }

      if (filterItem.field === 'roles.name') {
        return {
          ...filterItem,
          field: 'Role',
          value: filterItem?.value,
        }
      }

      if (filterItem.field === 'eligibleToClientAutoAssignments.name') {
        return {
          ...filterItem,
          field: 'AutoAssignment',
          value: filterItem?.value,
        }
      }

      if (filterItem.field === 'department.name') {
        return {
          ...filterItem,
          field: 'Departments',
          value: filterItem?.value,
        }
      }
      if (filterItem.field === 'local') {
        return {
          ...filterItem,
          field: 'Local',
          value: filterItem?.value,
        }
      }

      return filterItem
    }
  )

  return { ...gridFilterDescriptor, filters }
}
